/** 主题分类 */
interface ThemeClassItem {
  themeId: string;
  title: string;
  logo: string;
}
/** 主题卡片 */
interface ThemeCardItem {
  belongThemeId?: string;
  title: string;
  desc: string;
  logo: string;
  jumpType: 0 | 1;
  appid?: string;
  username?: string;
  path?: string;
  jumpUrl?: string;
  customEventKey?: string;
  // 投放计划 id
  dpId?: string;
}
/** 主题分类&卡片 */
export type ThemeItem = ThemeClassItem | ThemeCardItem;
/** 主题列表 */
export interface ThemeList {
  themeId: string;
  title: string;
  logo: string;
  list: ThemeCardItem[];
}

/** 简繁英 */
export type ThreeLanguage = {
  /** 繁体 */
  hk: string;
  /** 简体 */
  cn: string;
  /** 英文 */
  en: string;
};

/** 投放中台预期返回的banner位数据格式 */
export type ExpectedPropertyForBanner = {
  /** banner图片 */
  imgObj: ThreeLanguage;
  /** 无障碍 */
  bannerAltObj: ThreeLanguage;
  /** 点击上报扩展字段 */
  statClick: string;

  /** H5 banner URL */
  link?: string;

  /** 小程序banner，appid */
  appid?: string;
  /** 小程序banner，username */
  username?: string;
  /** 小程序banner，path */
  path?: string;
};

/** 多语言需要转换的 key */
export enum LangConfigKey {
  /** 标题 */
  'title' = 'title',
  /** 描述 */
  'desc' = 'desc',
  /** logo */
  'logo' = 'logo',
  /** 图片 */
  'imgObj' = 'imgObj',
  /** 图片无障碍 */
  'bannerAltObj' = 'bannerAltObj',
  /** 跳转链接 */
  'jumpUrl' = 'jumpUrl',
}

export enum ThemeCardType {
  'column' = 'column',
  'row' = 'row',
}

/** 扫码有礼模块信息 */
export type ScanGiftInfo = {
  banner: string;
  /** banner详情 */
  bannerDetail: {
    title: string,
    content: string
  };
  /** 点击banner跳转url(与弹框互斥） */
  bannerJumpUrl?: string;
  /** 商户ID */
  spId: string;
  campaignId: string;
  /** banner展示开始时间 */
  startTime: string;
  /** banner展示结束时间 */
  endTime: string;
};
